import { Alert, Platform } from 'react-native';

import i18n from '@i18n/i18n.config';

export const GRAPHQL_SERVER_ERROR_EVENT = 'graphql-server-error';

/**
 * User-facing notification for a handled server error (HTTP 5xx, or a GraphQL
 * `INTERNAL_ERROR` / `SERVICE_UNAVAILABLE`).
 *
 * TA-10138 (QA round 2): the AC requires the backend `request_id` to be
 * visible to the user so support can correlate a report with the backend
 * trace. Before this, requestId only reached Sentry (breadcrumb +
 * `captureMessage` extra) and the web event carried no detail, so
 * ServerErrorToast.web.tsx could only render the generic copy. requestId is
 * optional: network-level 5xx callers have no GraphQL body to read it from
 * and keep the generic message.
 *
 * QA round 3: extracted from useApolloClient.tsx so the native branch — the
 * only place request_id reaches a mobile user — is unit-testable. That file
 * pulls in react-native-mmkv and graphql-ws at import time, and is mocked
 * wholesale in jest.setup.js, so nothing there can be tested directly.
 */
export const notifyHandledGraphqlServerError = (requestId?: string) => {
  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    window.dispatchEvent(
      new CustomEvent(GRAPHQL_SERVER_ERROR_EVENT, { detail: { requestId } })
    );
    return;
  }

  Alert.alert(
    i18n.t('shared:error'),
    requestId
      ? i18n.t('shared:exceptionMsgWithRequestId', { requestId })
      : i18n.t('shared:exceptionMsg'),
    [{ text: 'OK' }]
  );
};
